/// Menu
import React, { useContext, useEffect, useReducer, useState } from "react";
import Collapse from 'react-bootstrap/Collapse';
import AdminNotificationService from "../../api/services/AdminNotificationService";



/// Link
import { Link } from "react-router-dom";

import { getMenuList } from './Menu';
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { ThemeContext } from "../../../context/ThemeContext";


const reducer = (previousState, updatedState) => ({
  ...previousState,
  ...updatedState,
});

const initialState = {
  active: "",
  activeSubmenu: "",
}

const SideBar = () => {
  // Compute menu list fresh on each render so role changes take effect
  const menuList = getMenuList();
  const {
    iconHover,
    sidebarposition,
    headerposition,
    sidebarLayout,
  } = useContext(ThemeContext);

  const [state, setState] = useReducer(reducer, initialState);

  //For scroll
  const [hideOnScroll, setHideOnScroll] = useState(true)
  const [newbooking, setNewbooking] = useState()
  const [newVoucher, setNewvoucher] = useState()
  const [newInquiry, setNewinquiry] = useState()
  const [newNewsletter, setNewnewsletter] = useState()
  const [newUserregister, setNewuserregister] = useState()
  const [newTripplan, setNewtripplan] = useState()
  // const [newuserdocument, setNewDocument] = useState()
  const [newcustomerdatabase, setNewcustomerdatabase] = useState()

  const Adminnotification = async () => {
    try {
      const response = await AdminNotificationService.Newbooking().json();
      const getvoucher = await AdminNotificationService.Newvoucher().json();
      const getinquiry = await AdminNotificationService.Newinquiry().json();
      const getnewsletter = await AdminNotificationService.Newnewsletter().json();
      const getuserregister = await AdminNotificationService.Newnuserregister().json();
      const gettripplan = await AdminNotificationService.Newtripplan().json();
      // const getdocument = await AdminNotificationService.NewDocument().json();
      // const getDatabase = await AdminNotificationService.NewDatabase().json();  
      
      setNewbooking(response.data.count ? response.data.count : 0);
      setNewvoucher(getvoucher.data.count ? getvoucher.data.count : 0);
      setNewinquiry(getinquiry.data.count ? getinquiry.data.count : 0);
      setNewnewsletter(getnewsletter.data.count ? getnewsletter.data.count : 0);
      setNewuserregister(getuserregister.data.count ? getuserregister.data.count : 0);
      setNewtripplan(gettripplan.data.count ? gettripplan.data.count : 0);
      // setNewDocument(getdocument.data.count ? getdocument.data.count : 0);
      // setNewcustomerdatabase(getDatabase.data.count ? getDatabase.data.count : 0);

    }
    catch (error) {
      console.log(error);

    }
  }
  useEffect(() => {
    Adminnotification()
  }, []);
 
  useScrollPosition(
    ({ prevPos, currPos }) => {
      const isShow = currPos.y > prevPos.y
      if (isShow !== hideOnScroll) setHideOnScroll(isShow)
    },
    [hideOnScroll]
  )


  const handleMenuActive = status => {
    setState({ active: status });
    if (state.active === status) {
      setState({ active: "" });
    }
  }
  const handleSubmenuActive = (status) => {

    setState({ activeSubmenu: status })
    if (state.activeSubmenu === status) {
      setState({ activeSubmenu: "" })
    }

  }


  // Menu dropdown list End

  /// Path
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];

  return (
    <div
      className={`deznav  border-right ${iconHover} ${sidebarposition.value === "fixed" &&
        sidebarLayout.value === "horizontal" &&
        headerposition.value === "static"
        ? hideOnScroll > 120
          ? "fixed"
          : ""
        : ""
        }`}
    >
      <div className="deznav-scroll" style={{ width: "max-content" }}>
        <ul className="metismenu" id="menu">
          {menuList.map((data, index) => {
            let menuClass = data.classsChange;
            if (menuClass === "menu-title") {
              return (
                <li className={menuClass} key={index} >
                  {data.title}
                </li>
              )
            } else {
              return (
                <li className={` ${state.active === data.title ? 'mm-active' : ''}`}
                  key={index}
                >

                  {data.content && data.content.length > 0 ?
                    <>
                      <Link to={"#"}
                        className="has-arrow"
                        onClick={() => { handleMenuActive(data.title) }}
                      >
                        <div className="menu-icon">
                          {data.iconStyle}
                        </div>
                        {" "}<span className="nav-text">{data.label ?? data.title}
                          {
                            data.update && data.update.length > 0 ?
                              <span className="badge badge-xs badge-danger ms-2">{data.update}</span>
                              :
                              ''
                          }
                        </span>
                      </Link>
                      <Collapse in={state.active === data.title ? true : false}>
                        <ul className={`${menuClass === "mm-collapse" ? "mm-show" : ""}`}>
                          {data.content && data.content.map((data, index) => {
                            return (
                              <li key={index}
                                className={`${state.activeSubmenu === data.title ? "mm-active" : ""}`}
                              >
                                {data.content && data.content.length > 0 ?
                                  <>
                                    <Link to={data.to} className={data.hasMenu ? 'has-arrow' : ''}
                                      onClick={() => { handleSubmenuActive(data.title) }}
                                    >
                                      {data.label ?? data.title}
                                    </Link>
                                    <Collapse in={state.activeSubmenu === data.title ? true : false}>
                                      <ul className={`${menuClass === "mm-collapse" ? "mm-show" : ""}`}>
                                        {data.content && data.content.map((data, ind) => {
                                          return (
                                            <li key={ind}>
                                              <Link className={`${path === data.to ? "mm-active" : ""}`} to={data.to}>{data.title}</Link>
                                            </li>
                                          )
                                        })}
                                      </ul>
                                    </Collapse>
                                  </>
                                  :
                                  <Link to={data.to}>
                                    {data.label ?? data.title}
                                  </Link>
                                }

                              </li>

                            )
                          })}
                        </ul>
                      </Collapse>
                    </>
                    :
                    <Link to={data.to} >
                      <div className="menu-icon">
                        {data.iconStyle}
                      </div>

                      <span className="nav-text">
                        {data.label ?? data.title}
                        {data.title === "Manage Booking" && newbooking > 0 && (
                          <span className="notificationcls">{newbooking}</span>
                        )}
                        {data.title === "Manage Voucher" && newVoucher > 0 && (
                          <span className="notificationcls">{newVoucher}</span>
                        )}
                        {data.title === "Inquiries" && newInquiry > 0 && (
                          <span className="notificationcls">{newInquiry}</span>
                        )}
                        {data.title === "Newsletters" && newNewsletter > 0 && (
                          <span className="notificationcls">{newNewsletter}</span>
                        )}
                        {data.title === "Login Accounts" && newUserregister > 0 && (
                          <span className="notificationcls">{newUserregister}</span>
                        )}
                        {data.title === "Manage Travel Planner" && newTripplan > 0 && (
                          <span className="notificationcls">{newTripplan}</span>
                        )} 
                        {/* {data.title === "Customer Database" && newcustomerdatabase > 0 && (
                          <span className="notificationcls">{newcustomerdatabase}</span>
                        )} */}
                      </span>

                      {
                        data.update && data.update.length > 0 ?
                          <span className="badge badge-xs badge-danger ms-2">{data.update}</span>
                          :
                          ''
                      }
                    </Link>
                  }

                </li>
              )
            }
          })}
        </ul>
      </div>
    </div>
  );
};

export default SideBar;
